module.exports = __webpack_public_path__ + "img/maria-profile.7ff09b52.png";